module.exports = __webpack_public_path__ + "media/images/icloud-1e3a8fa290061d396e907e3d7d1cee51.png";